module.exports = new __parcel__URL__("symsonic-hero.826b0761.mp3").toString();